import { useTheme } from '@mui/material/styles';
import { kFormatter } from './helper';

export const CustomYTickText = (props) => {
  const { payload, x, y } = props; // props from recharts
  const theme = useTheme();

  const value = '$' + kFormatter(payload.value);

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        fill={theme.fuel6Tokens.JddcColorTextSecondary}
        style={{ fontSize: 15 }}
        textAnchor="end"
        x={-5}
        y={5}
      >
        {value}
      </text>
    </g>
  );
};
